<template>
   <div :class="{'warning-icon':(!isMyUserAdmin)}" />
  <div :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}">
    <div class="col-sm-10 col-md-4 col-lg-3">
      
      <div ><DxButton  text="create new controller" width="100%" type="success" @click="showAddControllerForm"/></div>
      <div ><DxButton text="remove controller" width="100%" type="danger" @click="showConfirmationMessage_con"/></div>
      <div style="margin-left:-1.1em">
        <DxTreeView  
          :data-source="controllerTreeDS"
          data-structure="plain"
          selection-mode="single"
          :select-by-click="true"
          @item-click="treeCSelectionChange" />
      </div>
    </div>
    <div class="col-sm-12 col-md-8 col-lg-9">
      <div v-if="(!devViewCId)" class="position-relative" style="height: 25vh; min-height: 100px;">
        <div class="position-absolute top-50 start-50 translate-middle">
          <h3 class="text-center">Select an item from the list to view and edit its configuration</h3>
        </div>
      </div>
      <SocRecoveryEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==503)" :key="controllerData.id"/>  
      <PeakShavingEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==501)" :key="controllerData.id"/> 
      <TimeUseTariffEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==505)" :key="controllerData.id"/> 
      <ManualDispatchEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==506)" :key="controllerData.id"/> 
      <ZeroInjectionEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==502)" :key="controllerData.id"/> 
      <SimpleZeroInjectionEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==508)" :key="controllerData.id"/> 
      <MaxAutarchyEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==504)" :key="controllerData.id"/>
      <PCSDeltaEditor :controllerData="controllerData" :controllerList="controllerList" v-if="(controllerData.compType==507)" :key="controllerData.id"/>

    </div>
  </div>


  <DxPopup
    content-template="add-controller-form"
    title="Create a New Controller"
    max-width="430px"
    max-height="350px"
    :show-close-button="true"
    v-model:visible="isAddControllerFormVisible"
    :hide-on-outside-click="true">
    <template #add-controller-form>
      <DxScrollView width="100%" height="100%" >
        <AddControllerForm :controllerList="controllerList" :controllerNames="controllerTreeDS.items()" @cancel="hideAddControllerForm" @controller-update="(e)=>{hideAddControllerForm(); refreshControllerTree(); SelectionChange(e.data)}" />
      </DxScrollView>
    </template>            
  </DxPopup>

  <DxPopup
    content-template="confirm-delete-controller"
    :show-title="false"
    max-width="320px"
    max-height="100px"
    :show-close-button="false"
    v-model:visible="isShownConfirmationMessage_con"
    :hide-on-outside-click="false">
    <template #confirm-delete-controller>
      <p style="text-align: center;">Are you sure you want to delete this controller?</p>
      <div class="row mt-2">
      <div class="col"><DxButton text="Yes" @click="deleteSelectedController" type="normal" width="100%" height="30px" /></div>
      <div class="col"><DxButton text="No" @click="hideConfirmationMessage_con" type="danger" width="100%" height="30px"/></div>
      </div>
    </template>            
  </DxPopup>




</template>

<script>
import { ref, reactive, } from 'vue'
import DxButton from 'devextreme-vue/button';


import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import notify from 'devextreme/ui/notify';
import RawDataService from '../services/RawDataServiceTemplate';
import SocRecoveryEditor from './settings-controllers-SocRecovery.vue';
import PeakShavingEditor from './settings-controllers-PeakShaving.vue';
import TimeUseTariffEditor from './settings-controllers-TimeUseTariff.vue';
import ManualDispatchEditor from './settings-controllers-ManualDispatch.vue'; 
import ZeroInjectionEditor from './settings-controllers-ZeroInjection.vue';
import SimpleZeroInjectionEditor from './settings-controllers-SimpleZeroInjection.vue';
import MaxAutarchyEditor from './settings-controllers-MaxAutarchy.vue';
import PCSDeltaEditor from './settings-controllers-PCSDelta.vue';

import AddControllerForm from '../components/settings-create-controller.vue';
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { useStore } from 'vuex';
import { DxTreeView } from 'devextreme-vue/tree-view';
export default {
  components: {
    DxButton,
    DxPopup,
    DxScrollView,
    DxTreeView,

    SocRecoveryEditor,
    PeakShavingEditor,
    TimeUseTariffEditor,
    ManualDispatchEditor,
    ZeroInjectionEditor,
    SimpleZeroInjectionEditor,
    MaxAutarchyEditor,
    PCSDeltaEditor,
    AddControllerForm,
  
  },
  data(){
    return{
      controllerList :[
        {id:501, label:'Peak Shaving', ctrl:'PeakShaving'},
        {id:502, label:'Zero Injection', ctrl:'ZeroInjection'},
        {id:503, label:'SoC Recovery', ctrl:'SocRecovery'},
        {id:504, label:'Max Autarchy', ctrl:'MaxAutarchy'},
        {id:505, label:'Time of Use Tariff', ctrl:'TimeUseTariff'},
        {id:506, label:'Manual Dispatch', ctrl:'ManualDispatch'},
        {id:507, label:'PCS Delta', ctrl:'PCSDelta'},
        {id:508, label:'Simple Zero Injection', ctrl:'SimpleZeroInjection'}
      ],
    }
  },
  
  emits: ['controller-update', 'cancel'],
  setup() {
    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
    //
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const controllerDataService = new RawDataService('controllers');
    const componentsDataService = new RawDataService('masters/components');
   
    const controllerData = reactive({
      id:null,
      name: "",
      uuid: "",
      description: null,
      isEnabled: 0,
      compType:null,
      
    });

    // Navegation list of controllers
    const controllerTreeStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{
          let newDs = [];
          const controllerList = await controllerDataService.getAll();
          for(const controller of controllerList){
            newDs.push({
              id: controller.name, 
              text: controller.name, 
              description: controller.description 
            });
          }
          return newDs;
        }catch(err) { notify('error building the controllers tree: '+err.message, 'error', 4000); }
      }
    });

    const controllerTreeDS = new DataSource({
      store: controllerTreeStore,
      paginate: false
    });


    const isAddControllerFormVisible = ref(false);
    const showAddControllerForm = () => { isAddControllerFormVisible.value = true; }
    const hideAddControllerForm = () => { isAddControllerFormVisible.value = false; } 

    const devViewCId = ref(null);
    const treeCSelectionChange = (e) => {
      devViewCId.value = e.itemData.id;
      loadById(devViewCId.value);
    }
    const SelectionChange = (e) => {
      devViewCId.value = e.name;
      loadById(devViewCId.value);
    }
    const refreshControllerTree = async() => {
      return controllerTreeDS.reload();
    }
    const resetView = ()=>{
      devViewCId.value = null
      controllerData.compType=null
    }

    const isShownConfirmationMessage_con = ref(false)
    const showConfirmationMessage_con = () =>{
      if(!devViewCId.value) return notify('nothing to remove, no controller selected', "warning", 4000);
      isShownConfirmationMessage_con.value=true
    }
    const hideConfirmationMessage_con = () =>{
      isShownConfirmationMessage_con.value=false
    }
    const deleteSelectedController = async() => {
      hideConfirmationMessage_con()
      try{
        const response = await controllerDataService.remove(devViewCId.value);
        if(!response.isOk) throw new Error(response.message||''); 
        
        notify(response.message||'deletion sent', "success", 4000);
        
        refreshControllerTree();
        resetView()
      }
      catch(error){ 
        const message = error.data?.source_message || error.data?.message || 'unknown error processing request';
        notify(message, 'error', 4000); 
      }
    }
    

    // LOAD --------------
    const loadById = async (devViewCId) => {

      controllerDataService.getByKey(devViewCId).then(res => {
        Object.assign(controllerData, res);
        componentsDataService.getByKey('controller/'+controllerData.id).then(res =>{
          controllerData.connection_id = res.connection_id;
        })   
      }).catch(stErrorCb);

    }

    
    return {
      isMyUserAdmin,
      controllerData,    

      isAddControllerFormVisible,
      showAddControllerForm,
      hideAddControllerForm,
      isShownConfirmationMessage_con,
      showConfirmationMessage_con,
      hideConfirmationMessage_con,

      controllerTreeDS,
      refreshControllerTree,
      treeCSelectionChange,
      SelectionChange,
      deleteSelectedController,
      devViewCId,
    }
  },
}
</script>

<style>

</style>
